import React from "react";
import { CSVLink, CSVDownload } from "react-csv";

function flattenObject(obj, parent = "", sep = ".") {
  let flattened = {};

  for (let key in obj) {
    if (!obj.hasOwnProperty(key)) continue;

    // Construire une clé de parent si nécessaire
    let newKey = parent ? `${parent}${sep}${key}` : key;

    // Si la valeur est un objet, aplatissez récursivement
    if (typeof obj[key] === "object" && obj[key] !== null) {
      Object.assign(flattened, flattenObject(obj[key], newKey, sep));
    } else {
      flattened[newKey] = obj[key];
    }
  }

  return flattened;
}

function cleanObject(obj) {
  const flattened = flattenObject(obj);
  console.log({ obj });
  console.log({ flattened });
  let cleaned = {};

  // Supprimer les colonnes '__typename' et 'productId'
  for (let key in flattened) {
    if (!key.includes("__typename") && !key.includes("Id")) {
      cleaned[key] = flattened[key];
    }
  }

  console.log({ cleaned });
  return cleaned;
}

export const ExportCsv: React.FC<any> = ({
  data,
  filename = "supervision",
}) => {
  const [csvData, setCsvData] = React.useState<string[][]>([]);

  React.useEffect(() => {
    // first row is the header
    // keys of the first row and set them as the header
    if (data?.length > 0) {
      let header = Object.keys(data[0]);
      // maps data.scans.results to get values as array row
      let rows = data?.map((row) => {
        return Object.values(cleanObject(row));
      });
      // @ts-ignore
      setCsvData([header, ...rows]);
    }
  }, [data]);
  return (
    <div>
      <CSVLink
        className="btn"
        filename={`${filename}-supervision.csv`}
        data={csvData}
      >
        Telecharger le CSV
      </CSVLink>
      {/* <CSVDownload data={csvData} target="_blank" /> */}
    </div>
  );
};
